var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJnjIconHouse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 11.375H6.5625V7.00438H3.9375V11.375ZM10.9244 4.52375C10.5525 3.82375 10.8588 2.86125 9.95313 2.27938C9.065 1.71063 8.26 2.13937 7.71313 2.45437L5.25 0L0 5.2325V11.375H0.875V5.60438L5.25 1.23812L9.625 5.61312V11.375H11.305C11.1738 11.0556 11.0338 10.7056 10.9419 10.43C10.5963 9.37125 10.675 9.00812 10.9856 8.52687C11.515 7.71312 12.2894 7.47688 12.2456 6.57563C12.1931 5.40313 11.2481 5.13625 10.9244 4.52375Z",
    fill: "#0F68B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJnjIconHouse);
export default __webpack_public_path__ + "static/media/jnj-icon-house.fd8a00ab0c78d37ea30c65ac8e056e5e.svg";
export { ForwardRef as ReactComponent };